import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
// import { apiurl } from "../../../path"; // adjust path
import API from "../api";
const AddEmployee = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const [formData, setFormData] = useState({
        user_id: "",
        employee_Designation: "",
        phone_Number: "",
        created_Date: "",
        team_lead_id: ""
    });


    const [message, setMessage] = useState("");
    const [users, setUsers] = useState([]);



    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage("");
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [message]);

    useEffect(() => {
        fetchUsers();
    }, []);


    const fetchUsers = async () => {
        const res = await API.get("admin/getUsers");
        setUsers(res.data);
    };



    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.user_id === formData.team_lead_id) {
            setMessage("Employee and Lead cannot be same");
            return;
        }


        if (
            !formData.user_id ||
            !formData.employee_Designation ||
            !formData.phone_Number ||
            !formData.created_Date ||
            !formData.team_lead_id
        ) {
            setMessage("Please fill all fields");
            return;
        }


        try {
            // const res = await axios.post(`${apiurl}/addEmployee`, formData);
            const res = await API.post(
                "admin/addEmployee",
                formData
            );
            setMessage(res.data.message);

            setFormData({
                user_id: "",
                employee_Designation: "",
                phone_Number: "",
                created_Date: "",
                team_lead_id: ""
            });


        } catch (error) {
            setMessage("Error adding employee");
        }
    };

    return (
        <div className="dashboard-wrapper">
            <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
                <Sidebar />
            </div>

            <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
                <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

                <div className="main-content">
                    <div className="container-fluid py-4">

                        {/* Dashboard Title */}
                        <div className="dashboard-title">
                            <img
                                src="/Dashboard-Red-64.png"
                                alt="dashboard"
                                className="dashboard-icon"
                            />
                            <span>Add Employee</span>
                        </div>

                        {/* FORM CARD */}
                        <div className="search-card">
                            <h2>Add Employee Details</h2>
                        </div>

                        <div className="table-card">
                            <form onSubmit={handleSubmit} className="employee-form">

                                <div className="filter-row">

                                    <div className="filter-group">
                                        <label className="filter-label">Employee Name</label>
                                        <select
                                            name="user_id"
                                            value={formData.user_id}
                                            onChange={handleChange}
                                            className="filter-input"
                                        >
                                            <option value="">Select Employee</option>
                                            {users.map((user) => (
                                                <option key={user.id} value={user.id}>
                                                    {user.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>

                                    <div className="filter-group">
                                        <label className="filter-label">Designation</label>
                                        <input
                                            type="text"
                                            name="employee_Designation"
                                            value={formData.employee_Designation}
                                            onChange={handleChange}
                                            className="filter-input"
                                            placeholder="Enter Designation"
                                        />
                                    </div>
                                    <div className="filter-group">
                                        <label className="filter-label">Select Team Lead</label>
                                        <select
                                            name="team_lead_id"
                                            value={formData.team_lead_id}
                                            onChange={handleChange}
                                            className="filter-input"
                                        >
                                            <option value="">Select Team Lead</option>
                                            {users.map((user) => (
                                                <option key={user.id} value={user.id}>
                                                    {user.name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>


                                    <div className="filter-group">
                                        <label className="filter-label">Phone Number</label>
                                        <input
                                            type="text"
                                            name="phone_Number"
                                            value={formData.phone_Number}
                                            onChange={handleChange}
                                            className="filter-input"
                                            placeholder="Enter Phone Number"
                                        />
                                    </div>

                                    <div className="filter-group">
                                        <label className="filter-label">Created Date</label>
                                        <input
                                            type="date"
                                            name="created_Date"
                                            value={formData.created_Date}
                                            onChange={handleChange}
                                            className="filter-input"
                                        />
                                    </div>

                                </div>

                                <div style={{ marginTop: "20px" }}>
                                    <button type="submit" className="download-btn">
                                        ➕ Add Employee
                                    </button>
                                </div>

                                {message && (
                                    <p style={{ marginTop: "15px", color: "green" }}>
                                        {message}
                                    </p>
                                )}
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEmployee;
